import React from 'react';

import NavBar from '../components/NavBar';
import MyWork from '../components/MyWork';

const Project = () => {
    return (
        <div>
            <NavBar />
            <MyWork />
        </div>
    )
}


export default Project